export default __webpack_public_path__ + "static/media/m_engineering_card13_1.825e71c2.png";